import { render, staticRenderFns } from "./ImportOrdersModule.vue?vue&type=template&id=0b6c8108&scoped=true"
import script from "./ImportOrdersModule.vue?vue&type=script&lang=js"
export * from "./ImportOrdersModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c8108",
  null
  
)

export default component.exports